import 'babel-polyfill';
import React from 'react';
import {render} from 'react-dom';
import Routes from './routes';
import './styles/styles.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {Provider} from 'mobx-react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import injectTapEventPlugin from 'react-tap-event-plugin';
import * as api from './libs/api';

import DataSourceStore from  './store/DataSourceStore';
import UnitStore from  './store/UnitStore';

const dataSourceStore = new DataSourceStore(api.data_source);
const unitStore = new UnitStore(api.unit);

injectTapEventPlugin();

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#3c8dbc'
  },
  appBar: {
    height: 60,
  },
});

const App = () => (
  <Provider
    dataSourceStore={dataSourceStore}
    unitStore={unitStore}
  >
    <MuiThemeProvider muiTheme={muiTheme}>
      <Routes/>
    </MuiThemeProvider>
  </Provider>
);

render(
  <App/>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js